import React from 'react';
import styled from 'styled-components';
import { Rating } from '@mui/material';
import { StarBorder, Star } from '@mui/icons-material';

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 25px;
  transform: translateY(-50%);

  .MuiRating-iconFilled,
  .MuiRating-iconEmpty {
    color: #C4C4C4;
  }
`

const Feedback = () => (
  <Wrapper>
    <Rating
      name="customized-empty"
      defaultValue={2}
      precision={1}
      icon={<Star fontSize="large" />}
      emptyIcon={<StarBorder fontSize="large" />}
    />
  </Wrapper>
)

export default Feedback;
